var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label && _vm.icon)?_c('div',{on:{"click":function($event){return _vm.navigate()}}},[_c('ActionAtom',{attrs:{"text":_vm.label,"icon":_vm.icon,"action-class":"vuw-service-link"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }